"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAdAccountRequestToJSON = exports.CreateAdAccountRequestFromJSONTyped = exports.CreateAdAccountRequestFromJSON = exports.instanceOfCreateAdAccountRequest = void 0;
var runtime_1 = require("../runtime");
var AdAccountSource_1 = require("./AdAccountSource");
var AdAccountTaxObject_1 = require("./AdAccountTaxObject");
var BillingAddress_1 = require("./BillingAddress");
var Industry_1 = require("./Industry");
var Type_1 = require("./Type");
/**
 * Check if a given object implements the CreateAdAccountRequest interface.
 */
function instanceOfCreateAdAccountRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "industry" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "legalEntityName" in value;
    return isInstance;
}
exports.instanceOfCreateAdAccountRequest = instanceOfCreateAdAccountRequest;
function CreateAdAccountRequestFromJSON(json) {
    return CreateAdAccountRequestFromJSONTyped(json, false);
}
exports.CreateAdAccountRequestFromJSON = CreateAdAccountRequestFromJSON;
function CreateAdAccountRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : (0, AdAccountSource_1.AdAccountSourceFromJSON)(json['source']),
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'emailSubscribed': !(0, runtime_1.exists)(json, 'email_subscribed') ? undefined : json['email_subscribed'],
        'lead': !(0, runtime_1.exists)(json, 'lead') ? undefined : json['lead'],
        'leadId': !(0, runtime_1.exists)(json, 'lead_id') ? undefined : json['lead_id'],
        'invoiceEnabled': !(0, runtime_1.exists)(json, 'invoice_enabled') ? undefined : json['invoice_enabled'],
        'billToAddress': !(0, runtime_1.exists)(json, 'bill_to_address') ? undefined : (0, BillingAddress_1.BillingAddressFromJSON)(json['bill_to_address']),
        'taxIds': !(0, runtime_1.exists)(json, 'tax_ids') ? undefined : (json['tax_ids'].map(AdAccountTaxObject_1.AdAccountTaxObjectFromJSON)),
        'currencyCode': !(0, runtime_1.exists)(json, 'currency_code') ? undefined : json['currency_code'],
        'name': json['name'],
        'type': (0, Type_1.TypeFromJSON)(json['type']),
        'industry': (0, Industry_1.IndustryFromJSON)(json['industry']),
        'countryCode': json['country_code'],
        'legalEntityName': json['legal_entity_name'],
    };
}
exports.CreateAdAccountRequestFromJSONTyped = CreateAdAccountRequestFromJSONTyped;
function CreateAdAccountRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'source': (0, AdAccountSource_1.AdAccountSourceToJSON)(value.source),
        'email': value.email,
        'email_subscribed': value.emailSubscribed,
        'lead': value.lead,
        'lead_id': value.leadId,
        'invoice_enabled': value.invoiceEnabled,
        'bill_to_address': (0, BillingAddress_1.BillingAddressToJSON)(value.billToAddress),
        'tax_ids': value.taxIds === undefined ? undefined : (value.taxIds.map(AdAccountTaxObject_1.AdAccountTaxObjectToJSON)),
        'currency_code': value.currencyCode,
        'name': value.name,
        'type': (0, Type_1.TypeToJSON)(value.type),
        'industry': (0, Industry_1.IndustryToJSON)(value.industry),
        'country_code': value.countryCode,
        'legal_entity_name': value.legalEntityName,
    };
}
exports.CreateAdAccountRequestToJSON = CreateAdAccountRequestToJSON;
